/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Material Dashboard 2 PRO React components
import MDInput from "components/MDInput";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";

function FormDatePicker({ input, ...rest }) {
  const { label } = rest;
  let value = null;
  if (input.value !== null && input.value !== undefined && input.value !== "") {
    value = moment.isMoment(input.value) ? input.value : moment(input.value);
  }

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DatePicker
        {...rest}
        label={label}
        value={value}
        onChange={(newValue) => {
          input.onChange(newValue);
        }}
        // 1. Tell it to use your custom MDInput component
        slots={{
          textField: MDInput,
        }}
        // 2. Pass the standard MUI TextField props to MDInput
        slotProps={{
          textField: {
            variant: "standard",
            fullWidth: true,
            // If 'rest' contains error or helperText from a form library like Formik/Redux-Form:
            error: !!rest.error,
            helperText: rest.helperText,
          },
        }}
      />
    </LocalizationProvider>
  );
}

// Setting default values for the props of FormDatePîcker
FormDatePicker.defaultProps = {
  label: " ",
  input: {},
  meta: {
    touched: false,
    invalid: false,
    error: "",
  },
};

// Typechecking props for FormDatePicker
FormDatePicker.propTypes = {
  label: PropTypes.string,
  input: PropTypes.object,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    invalid: PropTypes.bool,
    error: PropTypes.string,
  }),
};

export default FormDatePicker;
